import { IntegrationsState } from '@modules/integrationsV2/store/types';

export const integrationsInitialState: IntegrationsState = {
  data: {
    fieldRelationsByType: [],
  },
  view: {
    isAddDrawerOpen: false,
    integrationTypeFilterInDrawer: 'all',
    selectedIntegrationIDToUpdate: null,
    selectedIntegrationToConnect: null,
    selectedIntegrationFormToConnect: null,
    selectedIntegrationSourceOption: null,
    isFieldRelationsQueryInProgress: false,
  },
};
